/**
 * The NextOpp mark.
 *
 * It was lucide's `Sparkles` in a blue square — the AI-product cliché, drawn
 * by the same icon set every competitor uses, and saying nothing about this
 * product beyond "there is a model in here somewhere."
 *
 * This is the site's one motif at its smallest size: three ascending strokes
 * over a horizon. The same shape is the section marker's altimeter, the same
 * rising diagonal is inside every icon in the family, and the tallest stroke
 * catches the dawn colour the whole page is lit by. A mark, a wayfinding
 * device and an icon language that are all the same idea.
 */
export default function Logomark({ className = "w-8 h-8", chip = true }) {
  const glyph = (
    // Drawn to fill the box. The first cut used 1.5-weight strokes across the
    // middle third of a 24 grid, which at a 32px chip is three grey hairlines
    // and a smudge. Marks have to be legible at 16px first and look good at
    // 200px second — not the other way round.
    <svg viewBox="0 0 24 24" fill="none" className={chip ? "w-5 h-5" : className} aria-hidden="true">
      <path d="M4.5 20h15" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" opacity="0.35" />
      <path d="M7 16.5V12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.6" />
      <path d="M12 16.5V8" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.85" />
      {/* the draft that arrived */}
      <path d="M17 16.5V3.5" stroke="#ff8f5e" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
  if (!chip) return glyph;
  return (
    <span className={`${className} bg-night text-white grid place-items-center rounded-sm shrink-0`}>
      {glyph}
    </span>
  );
}
